
































































































































































import { TenantInvitationModel, TenantUserModel } from '@/libs/Api';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { tenantInvitationsStore, tenantUsersStore } from '@/libs/tenants/+state/store';

import AccountDialog from '@/libs/settings/components/AccountDialog.vue';
import InviteAccountDialog from '../components/InviteAccountDialog.vue';
import DeleteDialog from '@/libs/common/components/DeleteDialog.vue';
import ExportDialog from '@/libs/common/components-smart/ExportDialog.vue';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';

@Component({
    components: {
        AccountDialog,
        InviteAccountDialog
    }
})
export default class Accounts extends Page {

    invitation: TenantInvitationModel | null = null;
    deleteInvitationDialog = false;
    deletingInvitation = false;
    tenantUser: TenantUserModel | null = null;
    deleting = false;
    districtFilter: string | null = null;
    accountTypeFilter: string | null = null;
    mobileFiltersShow = false;

    @Prop() tenantId!: string;

    @Ref() accountDialog!: AccountDialog;
    @Ref() inviteAccountDialog!: InviteAccountDialog;
    @Ref() exportDialog!: ExportDialog;
    @Ref() deleteDialog!: DeleteDialog;

    @Watch("districtFilter")
    @Watch("accountTypeFilter")
    filtersChanged () {
        this.load();
        this.loadInvitations();
    }

    get tableHeaders() {
        return [
            { text: this.$i18n.t("settings.accounts.columnEmail"), value: "email", align: "left" },
            { text: this.$i18n.t("settings.accounts.columnName"), value: "lastName", align: "left" },
            { text: this.$i18n.t("settings.accounts.columnAccountType"), value: "accountType", align: "left" },
            { text: this.$i18n.t("settings.accounts.columnDistrict"), value: "districtId", align: "left" },
            { text: this.$i18n.t("settings.accounts.columnPhoneNumber"), value: "phoneNumber", align: "left" },
            { text: "", value: "id", align: "right" }
        ];
    }

    get tableInvitationsHeaders() {
        return [
            { text: this.$i18n.t("settings.accounts.columnEmail"), value: "emailAddress", align: "left" },
            { text: this.$i18n.t("settings.accounts.columnAccountType"), value: "accountType", align: "left" },
            { text: this.$i18n.t("settings.accounts.columnDistrict"), value: "districtId", align: "left" },
            { text: "", value: "id", align: "right" }
        ];
    }

    get loading(): boolean {
        return tenantUsersStore.useGetter(CrudGetter.Pending);
    }

    get items(): TenantUserModel[] {
        return [...tenantUsersStore.useGetter(CrudGetter.Data)];
    }

    get loadingInvitations(): boolean {
        return tenantInvitationsStore.useGetter(CrudGetter.Pending);
    }

    get invitations (): TenantInvitationModel[] {
        return [...tenantInvitationsStore.useGetter(CrudGetter.Data)];
    }

    mounted () {
        this.load();
    }

    load () {
        this.loadItems();
        this.loadInvitations();
    }

    loadItems () {
        let filters: CrudQueryPredicate[] = [];
        if (this.districtFilter) 
            filters.push({
                field: "mainDistrictId",
                op: "eq",
                comparand: this.districtFilter
            });
        if (this.accountTypeFilter) 
            filters.push({
                field: "accountType",
                op: "eq",
                comparand: this.accountTypeFilter
            });
        tenantUsersStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<TenantUserModel>({ field: "User.Email", index: 1, order: "asc"}, filters));
    }

    loadInvitations () {
        let filters: CrudQueryPredicate[] = [
            { field: "isActive", op: "eq", comparand: true }
        ];
        if (this.districtFilter) 
            filters.push({
                field: "mainDistrictId",
                op: "eq",
                comparand: this.districtFilter
            });
        if (this.accountTypeFilter) 
            filters.push({
                field: "accountType",
                op: "eq",
                comparand: this.accountTypeFilter
            });
        tenantInvitationsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<TenantInvitationModel>({ field: "emailAddress", index: 1, order: "asc"}, filters));
    }

    createItemClick () {
        this.inviteAccountDialog.open();
    }

    openItemClick (item: TenantUserModel) {
        this.accountDialog.open(item.id);
    }

    exportClick () {
        this.exportDialog.open();
    }

    deleteInvitationClick (invitation: TenantInvitationModel) {
        this.invitation = invitation;
        this.deleteInvitationDialog = true;
    }

    deleteInvitation () {
        tenantInvitationsStore.dispatch(CrudAction.Delete, createCrudQueryPayload<TenantInvitationModel>(undefined, [
            { field: "id", op: "eq", comparand: this.invitation!.id! }
        ]));
        this.deletingInvitation = true;
        this.subscribe(tenantInvitationsStore, CrudReponse.Delete).then(() => {
            this.deleteInvitationDialog = false;
            this.deletingInvitation = false;
            this.loadInvitations();
        }).catch(() => {
            this.deletingInvitation = false;
        })

    }
    
    deleteItemClick (item: TenantUserModel) {
        this.deleteDialog.open();
        this.tenantUser = item;
    }

    deleteItem () {
        tenantUsersStore.dispatch(CrudAction.Delete, createCrudQueryPayload<TenantInvitationModel>(undefined, [
            { field: "id", op: "eq", comparand: this.tenantUser!.id! }
        ]));
        this.deleting = true;
        this.subscribe(tenantUsersStore, CrudReponse.Delete).then(() => {
            this.deleteDialog.close();
            this.deleting = false;
            this.loadInvitations();
        }).catch(() => {
            this.deleting = false;
        })

    }

}
